import { useSelector } from 'react-redux';
var ArticleContact = function ArticleContact(_ref) {
  var _contact$address, _contact$numbers, _contact$emails;
  var contactID = _ref.contactID;
  var contacts = useSelector(function (s) {
    return s.contacts;
  });
  var contact = contacts[contactID];
  var getType = function getType(type) {
    if (type === 'tel') return 'P: ';
    return 'F: ';
  };
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "article-contact__title"
  }, (contact === null || contact === void 0 ? void 0 : contact.title) || ''), /*#__PURE__*/React.createElement("div", null, contact === null || contact === void 0 ? void 0 : contact.name), contact === null || contact === void 0 ? void 0 : (_contact$address = contact.address) === null || _contact$address === void 0 ? void 0 : _contact$address.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: x._id
    }, /*#__PURE__*/React.createElement("span", null, x.street), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, x.city, ", ", x.state, ", ", x.zip));
  }), contact === null || contact === void 0 ? void 0 : (_contact$numbers = contact.numbers) === null || _contact$numbers === void 0 ? void 0 : _contact$numbers.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: x._id
    }, /*#__PURE__*/React.createElement("a", {
      href: 'tel:+1' + x.number.replace(/\./g, '')
    }, getType(x.type), " ", x.number.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3')));
  }), contact === null || contact === void 0 ? void 0 : (_contact$emails = contact.emails) === null || _contact$emails === void 0 ? void 0 : _contact$emails.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: x._id
    }, /*#__PURE__*/React.createElement("a", {
      href: 'mailto:' + x.address
    }, x.address));
  }));
};
export default ArticleContact;